import { render, staticRenderFns } from "./AccountOverview.vue?vue&type=template&id=bf38da82&scoped=true&"
import script from "./AccountOverview.vue?vue&type=script&lang=ts&"
export * from "./AccountOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AccountOverview.vue?vue&type=style&index=0&id=bf38da82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38da82",
  null
  
)

export default component.exports